import React from "react";
import { Box } from "@mui/material";
import { CreateButton } from "@refinedev/mui";

import { DataGrid } from "@shared/components/DataGrid";
import { FilterDropdown } from "@shared/components";
import { EndpointListFilters } from "@modules/erpIntegrations/components";
import { EndpointDialog } from "@modules/erpIntegrations/components/EndpointsPanel/EndpointDialog";
import { EndpointHistoryDialog } from "@modules/erpIntegrations/components/EndpointsPanel/EndpointHistoryDialog";

import { useEndpointsTab } from "./controller";
import { useEndpointsColumns } from "./columns";

export const EndpointsTab = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    integrations,
    translate,
    dialogEndpoint,
    openCreateDialog,
    openEditDialog,
    closeDialog,
    historyEndpoint,
    openHistory,
    closeHistory,
    handleDelete,
    handleToggleActive,
    handleSubmit,
    isSaving,
    isMutating,
    defaultIntegrationId,
  } = useEndpointsTab();

  const columns = useEndpointsColumns(translate, {
    onEdit: openEditDialog,
    onDelete: handleDelete,
    onHistory: openHistory,
    onToggleActive: handleToggleActive,
    isMutating,
  });

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mb: 1 }}>
        <FilterDropdown
          paramPrefix="endpoints_"
          initialValues={{ integration: "", search: "", method: "", active: "" }}
        >
          <EndpointListFilters />
        </FilterDropdown>
        <CreateButton onClick={openCreateDialog} />
      </Box>

      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        sortingOrder={["asc", "desc"]}
      />

      <EndpointDialog
        integrations={integrations}
        defaultIntegrationId={defaultIntegrationId}
        endpoint={dialogEndpoint}
        isSaving={isSaving}
        onClose={closeDialog}
        onOpenHistory={openHistory}
        onSubmit={handleSubmit}
      />
      <EndpointHistoryDialog endpoint={historyEndpoint} onClose={closeHistory} />
    </>
  );
});
